var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCardAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.833,
    r: 34.833,
    fill: "#FEBA05",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0398 37.4607H37.2029V48.2976C37.2029 48.8724 36.9745 49.4237 36.568 49.8302C36.1616 50.2366 35.6103 50.465 35.0355 50.465C34.4606 50.465 33.9094 50.2366 33.5029 49.8302C33.0964 49.4237 32.8681 48.8724 32.8681 48.2976V37.4607H22.0312C21.4563 37.4607 20.905 37.2323 20.4986 36.8258C20.0921 36.4194 19.8638 35.8681 19.8638 35.2933C19.8638 34.7184 20.0921 34.1672 20.4986 33.7607C20.905 33.3542 21.4563 33.1259 22.0312 33.1259H32.8681V22.289C32.8681 21.7141 33.0964 21.1629 33.5029 20.7564C33.9094 20.3499 34.4606 20.1216 35.0355 20.1216C35.6103 20.1216 36.1616 20.3499 36.568 20.7564C36.9745 21.1629 37.2029 21.7141 37.2029 22.289V33.1259H48.0398C48.6146 33.1259 49.1659 33.3542 49.5723 33.7607C49.9788 34.1672 50.2072 34.7184 50.2072 35.2933C50.2072 35.8681 49.9788 36.4194 49.5723 36.8258C49.1659 37.2323 48.6146 37.4607 48.0398 37.4607Z",
    fill: "#FEBA05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardAdd);
export default __webpack_public_path__ + "static/media/bank_card_add.5217a243406f6e6968350506b082a2db.svg";
export { ForwardRef as ReactComponent };